import {NbToastrConfig} from '@nebular/theme/components/toastr/toastr-config';

export const TOASTR_CONFIG /* : NbToastrConfig*/ = {
  // preventDuplicates: true,
  duration: 5000,
};
